import { useTheme } from '@/features/theme/useTheme';
import { useEffect, useRef } from 'react';
import { Toaster } from 'sonner';

/**
 * Toaster w warstwie „top layer” (Popover API). Natywne <dialog>.showModal()
 * leza w top layer i przykrywaly zwykle toasty — komunikat „Klient nie ma
 * maila” w podgladzie oferty byl niewidoczny (audyt 2026-09-29).
 * Po kazdym otwarciu dialogu ponownie pokazujemy popover, zeby byl na wierzchu
 * stosu top layer. Kolory z tokenow motywu (wczesniej zawsze ciemne).
 */
export function AppToaster() {
  const ref = useRef<HTMLDivElement>(null);
  const { resolved } = useTheme();

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof el.showPopover !== 'function') return;
    // Atrybut ustawiany w JS — typy React 18 nie znaja jeszcze `popover`.
    el.setAttribute('popover', 'manual');
    const raise = () => {
      if (el.matches(':popover-open')) el.hidePopover();
      el.showPopover();
    };
    raise();
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((m) => m.target instanceof HTMLDialogElement)) raise();
    });
    observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className="m-0 h-0 w-0 overflow-visible border-0 bg-transparent p-0">
      <Toaster
        theme={resolved}
        position="bottom-right"
        toastOptions={{
          style: {
            background: 'rgb(var(--color-surface-2))',
            color: 'rgb(var(--color-fg))',
            border: '1px solid var(--color-border)',
          },
        }}
      />
    </div>
  );
}
